import { Injectable } from '@angular/core';
import { Options } from 'select2';
import { ADDRESS1DB, ADDRESS3_LIST } from '@app/config/address.data';
import { path_module_admin, path_module_employee, path_module_employer, path_module_public } from '@app/models/routes.name'
import { ARR_TYPE_EMPLOYER } from '@app/config/employer-type.enum';
import { TYPE_CONTRACT } from '@app/config/type-contract.enum';
import { job_level, salary_level } from '@app/config/job-level.enum';
import { JOB_POSITION } from '@app/config/job-position.enum';
import { education_institution } from '@app/config/education-institution.enum';
import { education_status } from '@app/config/education-status.enum';
import { BENEFIT_NAME } from '@app/config/benefit-name.enum';
import { country } from '@app/config/country.enum';
import { GENDER_NAME } from '@app/config/gender-name.enum';
import { job_mode } from '@app/config/job-mode.enum';
import { user_status } from '@app/config/user-status.enum';
import { Select2OptionData } from 'ng-select2';
import { role_name } from '@app/config/role-name.enum';
import { environment } from '@env/environment';
import { recognition_options } from '@app/config/recognition.enum';
import { pd_options, percentage_options } from '@app/config/priority-difficult.enum';
import { TIC_NAME, TIC_NAME_GROUPED } from '@app/config/tic-name.enum';
import { job_status } from 'functions/src/help/job-status.enum';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {

  readonly dataSelectJobPosition = Object.values(JOB_POSITION).filter((item) => { return isNaN(Number(item)) }).map(x => { return x.text });
  readonly dataSelectJobLevel = Object.values(job_level).filter((item) => { return isNaN(Number(item)) }).map(x => { return x.text });
  readonly dataSelectSalaryLevel = Object.values(salary_level).filter((item) => { return isNaN(Number(item)) }).map(x => { return x.text });
  readonly dataSelectTypeEmployer = ARR_TYPE_EMPLOYER.map(x => { return x.text });
  readonly dataSelectEducationStatus = Object.values(education_status).filter((item) => { return isNaN(Number(item)) });
  readonly dataSelectTypeContract = Object.values(TYPE_CONTRACT).filter((item) => { return isNaN(Number(item)) });
  readonly dataSelectRecognition = Object.values(recognition_options).filter((item) => { return isNaN(Number(item)) });
  readonly dataSelectPD = Object.values(pd_options).filter((item) => { return isNaN(Number(item)) });
  readonly dataSelectPercentage = Object.values(percentage_options).filter((item) => { return isNaN(Number(item)) });
  readonly dataSelectEducationInstitution = Object.values(education_institution).filter((item) => { return isNaN(Number(item)) });
  readonly dataSelectBenefit = BENEFIT_NAME.map(b => { return b });
  readonly dataSelectTic = TIC_NAME.map(b => { return b });
  readonly dataSelectTicGrouped = TIC_NAME_GROUPED.map(b => { return b });
  readonly dataSelectCountry = Object.values(country).filter((item) => { return isNaN(Number(item)) });
  readonly dataSelectGender = [GENDER_NAME.Male, GENDER_NAME.Female];

  readonly dataSelectJobMode = [job_mode.Remote, job_mode.Presential];
  readonly dataSelectJobStatus = [job_status.open, job_status.closed];
  readonly dataSelectUserStatus = [user_status.Enabled, user_status.Disabled, user_status.All];
  readonly dataSelectUserProfile = [role_name.Employee, role_name.Employer];

  readonly genderList = GENDER_NAME;

  constructor() {
    this.dataSelectJobPosition.map((e: any) => { this.dataSelect2Position = [...this.dataSelect2Position, { id: e, text: e }]; });
    this.dataSelectJobLevel.map((e: any) => { this.dataSelect2Level = [...this.dataSelect2Level, { id: e, text: e }]; });
    this.dataSelectEducationInstitution.map((e: any) => { this.dataSelect2EducationInstitution = [...this.dataSelect2EducationInstitution, { id: e, text: e }]; });
    BENEFIT_NAME.map(b => { this.dataSelect2Benefit = [...this.dataSelect2Benefit, { id: b.id.toString(), text: b.name, additional: b.ico }]; });
    TIC_NAME.map(b => { this.dataSelect2Tic = [...this.dataSelect2Tic, { id: b.id.toString(), text: b.name }]; });
  }

  //data to fill ng-select-2
  public dataSelect2EducationSubject: Array<Select2OptionData> = [];
  public dataSelect2Position: Array<Select2OptionData> = [];
  public dataSelect2Level: Array<Select2OptionData> = [];
  public dataSelect2EducationInstitution: Array<Select2OptionData> = [];
  public dataSelect2EducationLevel: Array<Select2OptionData> = [];
  public dataSelect2Benefit: Array<Select2OptionData> = [];
  public dataSelect2Tic: Array<Select2OptionData> = [];

  //options ng-select-2
  public readonly optionsSelect2MultipleWithoutTag: Options = { language: "es", multiple: true, tags: false, closeOnSelect: false };
  public readonly optionsSelect2MultipleWithTag: Options = { language: "es", multiple: true, tags: true, closeOnSelect: true };
  public readonly optionsSelect2SingleWithoutTag: Options = { language: "es", multiple: false, tags: false };
  public readonly optionsSelect2SingleWithTag: Options = { language: "es", multiple: false, tags: true };
  public readonly optionsSelect2InstitutionList: Options = {
    language: "es",
    multiple: false,
    tags: false,
    ajax: {
      url: environment.endpoint.apiemployer + "search/institution/",
      dataType: 'json',
      delay: 250,
      data: function (params) {
        return {
          optionFilter: params.term,
          page: params.page
        };
      },
      processResults: function (data, params) {
        params.page = params.page || 1;

        // Verificar si data.results existe, si no, usar data directamente
        const results = data.results || data;

        return {
          results: $.map(results, function (item) {
            return {
              text: item.name,
              id: item.name
            }
          }),
          pagination: {
            more: data.recordsPerPage ? (params.page * data.recordsPerPage) < data.recordsCount : false
          }
        };
      },
      cache: true
    }
  };

  public readonly optionsSelect2CourseInstitution: Options = {
    language: "es",
    multiple: false,
    tags: false,
    ajax: {
      url: environment.endpoint.apiconfig + "search/courseinstitution/",
      dataType: 'json',
      delay: 250,
      data: function (params) {
        return {
          optionFilter: params.term,
          page: params.page
        };
      },
      processResults: function (data, params) {

        params.page = params.page || 1;

        return {
          results: $.map(data.results, function (item) {
            return {
              text: item.name,
              id: item.name
            }
          },
          ),
          pagination: {
            more: (params.page * data.recordsPerPage) < data.recordsCount
          }
        };
      },
      cache: true
    }
  };

  public readonly optionsSelect2CourseName: Options = {
    language: "es",
    multiple: false,
    tags: false,
    ajax: {
      url: environment.endpoint.apiconfig + "search/course/",
      dataType: 'json',
      delay: 250,
      data: function (params) {
        return {
          optionFilter: params.term,
          page: params.page
        };
      },
      processResults: function (data, params) {

        params.page = params.page || 1;

        return {
          results: $.map(data.results, function (item) {
            return {
              text: item.name,
              id: item.name
            }
          },
          ),
          pagination: {
            more: (params.page * data.recordsPerPage) < data.recordsCount
          }
        };
      },
      cache: true
    }
  };

  readonly dataSelectAddress1 = ADDRESS1DB;
  readonly dataSelectAddress3 = ADDRESS3_LIST.sort((a, b) => a.text.localeCompare(b.text)).map(e => { return { id: e.id, address1: e.parent, address3: e.text } })

  // lazy loading
  readonly PATH_EMPLOYEE_MODULE: string = path_module_employee.module;
  readonly PATH_EMPLOYEE_APPLICATIONS: string = `${path_module_employee.module}/${path_module_employee.applications}`;
  readonly PATH_EMPLOYEE_CHAT: string = `${path_module_employee.module}/${path_module_employee.chat}`;
  readonly BASE_PATH_EMPLOYEE_BASIC: string = `${path_module_employee.module}/${path_module_employee.form_basic}`;
  readonly BASE_PATH_EMPLOYEE_EDIT: string = `${path_module_employee.module}/${path_module_employee.edit_profile}`;
  readonly BASE_PATH_EMPLOYEE_RESUME_SEND: string = `${path_module_employee.module}/${path_module_employee.resume_send}`;

  readonly BASE_PATH_EMPLOYEE_LANDING: string = path_module_public.employee_landing;
  readonly BASE_PATH_EMPLOYEE_LANDING_FACEBOOK: string = path_module_public.employee_landing_facebook;
  readonly BASE_PATH_LANDING_RESUME_SEND: string = path_module_public.landing_resume_send;

  //public
  readonly BASE_PATH_EMPLOYER_TERM: string = path_module_public.employer_term;
  readonly BASE_PATH_EMPLOYEE_TERM: string = path_module_public.employee_term;

  //admin
  readonly BASE_PATH_MODULE_ADMIN: string = `${path_module_admin.module}`;
  readonly BASE_PATH_ADMIN_REPORT: string = `${path_module_admin.module}/${path_module_admin.report}`;
  readonly BASE_PATH_ADMIN_EMPLOYER: string = `${path_module_admin.module}/${path_module_admin.employer}`;
  readonly BASE_PATH_ADMIN_SALARIES: string = `${path_module_admin.module}/${path_module_admin.salaries}`;
  readonly BASE_PATH_ADMIN_CUSTOMER_SUCCESS: string = `${path_module_admin.module}/${path_module_admin.customer_success}`;
  readonly BASE_PATH_ADMIN_PSYCHO_INTERVIEW: string = `${path_module_admin.module}/${path_module_admin.psycho_interview}`;
  readonly BASE_PATH_ADMIN_JOB_REFERENCE: string = `${path_module_admin.module}/${path_module_admin.job_reference}`;
  readonly BASE_PATH_ADMIN_PROSPECTING: string = `${path_module_admin.module}/${path_module_admin.prospecting}`;
  readonly BASE_PATH_ADMIN_PROSPECTING_VALIDATION: string = `${path_module_admin.module}/${path_module_admin.prospecting_validation}`;
  readonly BASE_PATH_ADMIN_EMPLOYEE: string = `${path_module_admin.module}/${path_module_admin.employee}`;
  readonly BASE_PATH_LOGIN_ADMIN: string = `${path_module_admin.module}/${path_module_admin.login}`;
  readonly BASE_PATH_SEARCHEMPLOYEE: string = `${path_module_admin.module}/${path_module_admin.searchemployee}`;
  readonly BASE_PATH_RECOMENDATION: string = `${path_module_admin.module}/${path_module_admin.recomendation}`;

  readonly BASE_PATH_JOB_SEARCH: string = path_module_public.advice;
  readonly BASE_PATH_INSTITUTION_SEARCH: string = path_module_public.institution_search;
  readonly BASE_PATH_JOB_VIEW: string = path_module_public.advice;
  readonly BASE_PATH_SALARIES_VIEW: string = path_module_public.salaries;

  //employer
  readonly BASE_PATH_EMPLOYER: string = `${path_module_employer.module}/${path_module_employer.sign_up}`;
  readonly BASE_PATH_JOB: string = `${path_module_employer.module}/${path_module_employer.job}`;
  readonly BASE_PATH_EMPLOYER_JOB: string = `${path_module_employer.module}/${path_module_employer.job_list}`;
  readonly BASE_PATH_EMPLOYER_SEARCH_TALENT: string = `${path_module_employer.module}/${path_module_employer.search_talent}`;
  readonly BASE_PATH_EMPLOYER_EDIT: string = `${path_module_employer.module}/${path_module_employer.edit}`;
  readonly BASE_PATH_EMPLOYER_PSYCHO_INTERVIEW: string = `${path_module_employer.module}/${path_module_employer.psycho_interview}`;
  readonly BASE_PATH_PASSWORD_EMPLOYER: string = `${path_module_employer.module}/${path_module_employer.password}`;
  readonly BASE_PATH_LOGIN_EMPLOYER: string = `${path_module_employer.module}/${path_module_employer.login}`;

  readonly BASE_PATH_PASSWORD_EMPLOYEE: string = `${path_module_employee.module}/${path_module_employee.password}`;
  readonly BASE_PATH_LOGIN_EMPLOYEE: string = `${path_module_employee.module}/${path_module_employee.login}`;

  readonly BASE_PATH_NOT_FOUND: string = path_module_public.not_found;
  readonly BASE_PATH_CHANGEPASS: string = path_module_public.changepass;
  readonly BASE_PATH_RESETPASS: string = path_module_public.resetpass;
  readonly BASE_PATH_VERIFYEMAIL: string = path_module_public.verifyemail;
  readonly BASE_PATH_CREATEPASS: string = path_module_public.createpass;
  readonly BASE_PATH_FAQ: string = path_module_public.faq;
  readonly BASE_PATH_LANDING_PREMIUM: string = path_module_public.landing_premium;

  readonly BASE_PATH_HOME: string = path_module_public.home;
  readonly BASE_PATH_HOME_ADMIN: string = this.BASE_PATH_HOME;
  readonly BASE_PATH_HOME_EMPLOYEE: string = this.BASE_PATH_HOME;
  readonly BASE_PATH_HOME_EMPLOYER: string = this.BASE_PATH_HOME;

  //dataset for list of checkbox
  readonly dataSelectAddress1List = [
    'Región de Arica y Parinacota',
    'Región de Tarapacá',
    'Región de Antofagasta',
    'Región de Atacama',
    'Región de Coquimbo',
    'Región de Valparaiso',
    'Región Metropolitana de Santiago',
    'Región del Libertador General Bernardo O\'Higgins',
    'Región del Maule',
    'Región de Ñuble',
    'Región del Biobío',
    'Región de La Araucanía',
    'Región de Los Ríos',
    'Región de Los Lagos',
    'Región de Aysén del General Carlos Ibáñez del Campo',
    'Región de Magallanes y de la Antártica Chilena'
  ];
  readonly dataYesNo = [
    "Sí",
    "No"
  ]

  readonly dataBrp = [
    "No",
    "Sí, recibo BRP Título",
    "Sí, recibo BRP Título y Mención"
  ]

  readonly dataSelectInstitutionEducation = ["Centro De Formación Técnica Accioma", "Centro De Formación Técnica Alfa", "Centro De Formación Técnica Alpes", "Centro De Formación Técnica Barros Arana", "Centro De Formación Técnica Ceduc - Ucn", "Centro De Formación Técnica Ceitec", "Centro De Formación Técnica Cenco", "Centro De Formación Técnica Centro De Enseñanza De Alta Costura Paulina Diard", "Centro De Formación Técnica Centro Tecnológico Superior Infomed", "Centro De Formación Técnica Cámara De Comercio De Santiago", "Centro De Formación Técnica De Enac O Centro De Formación Técnica De Los Establecimientos Nacionales De Educación Cáritas-Chile", "Centro De Formación Técnica De La Industria Gráfica O Cft. Ingraf", "Centro De Formación Técnica De La Pontificia Universidad Católica De Valparaíso O Cft Pucv", "Centro De Formación Técnica De La Región De Coquimbo", "Centro De Formación Técnica De La Región De La Araucanía", "Centro De Formación Técnica De La Región De Los Lagos", "Centro De Formación Técnica De La Región De Tarapacá", "Centro De Formación Técnica De La Región Del Maule", "Centro De Formación Técnica De La Universidad De Valparaíso O Cft Uv", "Centro De Formación Técnica De Tarapacá", "Centro De Formación Técnica Del Medio Ambiente", "Centro De Formación Técnica Educap", "Centro De Formación Técnica Escuela Culinaria Francesa", "Centro De Formación Técnica Escuela Superior De Administración De Negocios Del Norte - Esane Del Norte '", "Centro De Formación Técnica Estudio Profesor Valero", "Centro De Formación Técnica Icel", "Centro De Formación Técnica Inacap", "Centro De Formación Técnica Instituto Central De Capacitación Educacional Icce", "Centro De Formación Técnica Instituto Superior Alemán De Comercio Insalco", "Centro De Formación Técnica Instituto Superior De Estudios Jurídicos Canon", "Centro De Formación Técnica Instituto Técnológico De Chile - I.T.C", "Centro De Formación Técnica Iprosec", "Centro De Formación Técnica Juan Bohon", "Centro De Formación Técnica Laplace O C.F.T.  De Estudios Superiores Y Capacitación Profesional Laplace", "Centro De Formación Técnica Los Lagos", "Centro De Formación Técnica Lota-Arauco", "Centro De Formación Técnica Manpower", "Centro De Formación Técnica Massachusetts", "Centro De Formación Técnica Proandes", "Centro De Formación Técnica Prodata", "Centro De Formación Técnica Profasoc", "Centro De Formación Técnica Protec", "Centro De Formación Técnica San Agustín De Talca", "Centro De Formación Técnica Santo Tomás", "Centro De Formación Técnica Teodoro Wickel Kluwen", "Instituto Nacional De Capacitación Profesional Inacap", "Instituto Profesional Adventista", "Instituto Profesional Agrario Adolfo Matthei", "Instituto Profesional Aiep", "Instituto Profesional Alemán Wilhelm Von Humboldt", "Instituto Profesional Carlos Casanueva", "Instituto Profesional Ciisa", "Instituto Profesional De Arte Y Comunicación Arcos", "Instituto Profesional De Artes Escénicas Karen Connolly", "Instituto Profesional De Chile", "Instituto Profesional De Ciencias De La Computación Acuario Data", "Instituto Profesional De Ciencias Y Educación Helen Keller", "Instituto Profesional De Los Angeles", "Instituto Profesional Del Comercio", "Instituto Profesional Del Valle Central", "Instituto Profesional Diego Portales", "Instituto Profesional Dr. Virginio Gómez G", "Instituto Profesional Duoc Uc", "Instituto Profesional Eatri Instituto Profesional", "Instituto Profesional Escuela De Cine De Chile", "Instituto Profesional Escuela De Contadores Auditores De Santiago", "Instituto Profesional Escuela De Marina Mercante Piloto Pardo", "Instituto Profesional Escuela Moderna De Música", "Instituto Profesional Esucomex", "Instituto Profesional Inacap O Instituto Profesional", "Instituto Profesional Instituto De Estudios Bancarios Guillermo Subercaseaux", "Instituto Profesional Instituto Internacional De Artes Culinarias Y Servicios", "Instituto Profesional Instituto Nacional Del Fútbol", "Instituto Profesional Instituto Superior De Artes Y Ciencias De La Comunicación", "Instituto Profesional Ipg", "Instituto Profesional La Araucana", "Instituto Profesional Latinoamericano De Comercio Exterior - Iplacex", "Instituto Profesional Libertador De Los Andes", "Instituto Profesional Los Lagos", "Instituto Profesional Los Leones", "Instituto Profesional Projazz", "Instituto Profesional Providencia", "Instituto Profesional Santo Tomás", "Instituto Profesional Vertical Instituto Profesional", "Pontificia Universidad Católica De Chile", "Pontificia Universidad Católica De Valparaíso", "Universidad Academia De Humanismo Cristiano", "Universidad Adolfo Ibañez", "Universidad Adventista De Chile", "Universidad Alberto Hurtado", "Universidad Andrés Bello", "Universidad Arturo Prat", "Universidad Austral De Chile", "Universidad Autónoma De Chile", "Universidad Bernardo O\'Higgins", "Universidad Bolivariana", "Universidad Católica Cardenal Raúl Silva Henríquez", "Universidad Católica De La Santísima Concepción", "Universidad Católica De Temuco", "Universidad Católica Del Maule", "Universidad Católica Del Norte", "Universidad Central De Chile", "Universidad De Aconcagua", "Universidad De Antofagasta", "Universidad De Artes, Ciencias Y Comunicación - Uniacc", "Universidad De Atacama", "Universidad De Aysén", "Universidad De Chile", "Universidad De Concepción", "Universidad De La Frontera", "Universidad De La Serena", "Universidad De Las Américas", "Universidad De Los Andes", "Universidad De Los Lagos", "Universidad De Magallanes", "Universidad De O\'Higgins", "Universidad De Playa Ancha De Ciencias De La Educación", "Universidad De Santiago De Chile", "Universidad De Talca", "Universidad De Tarapacá", "Universidad De Valparaíso", "Universidad De Viña Del Mar", "Universidad Del Bío-Bío", "Universidad Del Desarrollo", "Universidad Del Pacífico", "Universidad Diego Portales", "Universidad Finis Terrae", "Universidad Gabriela Mistral", "Universidad La República", "Universidad Los Leones", "Universidad Mayor", "Universidad Metropolitana De Ciencias De La Educación", "Universidad Miguel De Cervantes", "Universidad Pedro De Valdivia", "Universidad San Sebastián", "Universidad Santo Tomás", "Universidad Sek", "Universidad Tecnológica De Chile Inacap", "Universidad Tecnológica Metropolitana", "Universidad Técnica Federico Santa María", "Universidad Ucinf"];


  readonly defaultHourRangeSearch = [1, 45];
  readonly defaultHourRangeMin = 1;
  readonly defaultHourRangeMax = 45;
  readonly defaultHourRangeStep = 1;

  readonly defaultSalaryRange = [300000, 1000000];
  readonly defaultSalaryRangeSearch = [0, 0];
  readonly defaultSalaryRangeForm = [0, 0];

  readonly defaultSalaryRangeMin = 0;
  readonly defaultSalaryRangeMax = 3000000;
  readonly defaultSalaryRangeStep = 50000;

  readonly defaultExperienceYearRange = [0, 40];
  readonly defaultExperienceYearMin = 0;
  readonly defaultExperienceYearMax = 40;
  readonly defaultExperienceYearStep = 1;

  readonly defaultExperienceEmployerRange = [0, 30];
  readonly defaultExperienceEmployerMin = 0;
  readonly defaultExperienceEmployerMax = 30;
  readonly defaultExperienceEmployerStep = 1;

  readonly defaultAgeRange = [20, 100];
  readonly defaultAgeMin = 20;
  readonly defaultAgeMax = 100;
  readonly defaultAgeStep = 1;

  defaultEnglishLevelSearchMin = 0;
  defaultEnglishLevelSearchMax = 4;
  defaultEnglishLevelSearchStep = 1;
  defaultEnglishLevelSearchConnect = "upper";
  defaultEnglishLevelSearchRange = [this.defaultEnglishLevelSearchMin];

  defaultPriorityLevelSearchMin = 0;
  defaultPriorityLevelSearchMax = 5;
  defaultPriorityLevelSearchStep = 1;
  defaultPriorityLevelSearchConnect = "upper";
  defaultPriorityLevelSearchRange = [this.defaultPriorityLevelSearchMin];
}
